import React, { useEffect, useState } from 'react';
import { useReveal } from '../lib/useReveal';
export function UrgencySection() {
  const [ref, vis] = useReveal();
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 15 * 60;
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section className="bg-brand-timer py-6 md:py-8 px-5 sm:px-6 border-t border-brand-border-soft" data-id="element-299">
      <div className="container mx-auto max-w-3xl" data-id="element-300">
        <div ref={ref} className={`reveal text-center ${vis ? 'is-visible' : ''}`} data-id="element-301">
          <div className="inline-block bg-white/10 border border-white/20 rounded-2xl p-6 md:p-8 w-full shadow-medium backdrop-blur-sm" data-id="element-302">
            <h3 className="text-white font-bold text-sm md:text-base tracking-widest uppercase mb-4" data-id="element-303">
              ⏰ PRECIO DE RELANZAMIENTO — CIERRA EN:
            </h3>

            <div className="flex justify-center items-center gap-2 md:gap-4 mb-4" data-id="element-304">
              <div className="flex flex-col items-center" data-id="element-305">
                <div className="bg-white/20 border border-white/30 rounded-lg w-16 h-16 md:w-20 md:h-20 flex items-center justify-center text-2xl md:text-4xl font-bold text-white font-serif" data-id="element-306">
                  {hours.toString().padStart(2, '0')}
                </div>
                <span className="text-white/70 text-xs mt-2 uppercase tracking-wider" data-id="element-307">
                  hs
                </span>
              </div>
              <span className="text-2xl md:text-4xl font-bold text-white/50 pb-6" data-id="element-308">
                :
              </span>
              <div className="flex flex-col items-center" data-id="element-309">
                <div className="bg-white/20 border border-white/30 rounded-lg w-16 h-16 md:w-20 md:h-20 flex items-center justify-center text-2xl md:text-4xl font-bold text-white font-serif" data-id="element-310">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <span className="text-white/70 text-xs mt-2 uppercase tracking-wider" data-id="element-311">
                  min
                </span>
              </div>
              <span className="text-2xl md:text-4xl font-bold text-white/50 pb-6" data-id="element-312">
                :
              </span>
              <div className="flex flex-col items-center" data-id="element-313">
                <div className="bg-white/20 border border-white/30 rounded-lg w-16 h-16 md:w-20 md:h-20 flex items-center justify-center text-2xl md:text-4xl font-bold text-[#FCE4EC] font-serif" data-id="element-314">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <span className="text-white/70 text-xs mt-2 uppercase tracking-wider" data-id="element-315">
                  seg
                </span>
              </div>
            </div>

            <p className="text-[#FCE4EC] font-bold text-sm md:text-base mb-6" data-id="element-316">
              ⚠️ Después sube. No vuelve.
            </p>

            <div className="w-full max-w-md mx-auto text-left" data-id="element-317">
              <div className="flex justify-between text-xs md:text-sm font-bold mb-2" data-id="element-318">
                <span className="text-white" data-id="element-319">
                  🔴 Cupos al precio de relanzamiento
                </span>
                <span className="text-white" data-id="element-320">72%</span>
              </div>
              <div className="w-full bg-black/20 rounded-full h-2.5 border border-white/10 overflow-hidden" data-id="element-321">
                <div className="bg-gradient-to-r from-[#C4788A] to-[#FCE4EC] h-2.5 rounded-full" style={{
                width: '72%'
              }} data-id="element-322"></div>
              </div>
              <p className="text-white/70 text-xs text-center mt-2" data-id="element-323">
                72% de los cupos ya fueron tomados
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}